import { createSlice } from "@reduxjs/toolkit";

export const Error429Prompt = createSlice({
  name: "error_429_prompt",
  initialState: {
    value: {
      status: false,
      isTooManyRequest: false,
    },
  },
  reducers: {
    onTooManyRequest: (state, action) => {
      state.value.isTooManyRequest = true;
    },
  },
});

export const { onTooManyRequest } = Error429Prompt.actions;

export default Error429Prompt.reducer;
